// Utility helpers for Galaxy Gate widget.

export const normalizeSource = (guest = {}) => {
  const utm = guest.utm || {};
  const query = guest.query || {};
  const ref =
    guest.referrer ||
    utm.referrer ||
    utm.ref ||
    query.referrer ||
    guest.query?.referrer;
  const origin = guest.origin;
  const utmSource =
    guest.utmSource ||
    utm.utmSource ||
    query.utmSource ||
    guest.utm_source ||
    utm.utm_source ||
    query.utm_source;
  const refHost = extractReferrerHost({ referrer: ref }) || '';
  const originHost = extractReferrerHost({ referrer: origin }) || '';
  const currentHost =
    typeof window !== 'undefined' ? window.location.hostname : null;
  const sourceHost =
    refHost && refHost !== 'unknown'
      ? refHost
      : originHost && originHost !== 'unknown' && originHost !== currentHost
        ? originHost
        : '';
  const lower = (utmSource || sourceHost || 'direct').toLowerCase();
  if (lower.includes('twitter') || lower === 'x') return 'twitter';
  if (lower.includes('tiktok')) return 'tiktok';
  if (lower.includes('google')) return 'google';
  if (lower === 'direct' || lower === 'none' || lower === '') return 'direct';
  if (lower.includes('influencer') || lower.includes('referral')) return 'influencer';
  const maybeUrl = ref;
  if (maybeUrl && typeof maybeUrl === 'string' && maybeUrl.startsWith('http')) {
    try {
      const url = new URL(maybeUrl);
      return url.hostname || 'unknown';
    } catch {
      return maybeUrl || 'unknown';
    }
  }
  return lower || 'unknown';
};

export const maskId = (id) => {
  if (!id) return 'guest';
  const str = String(id);
  if (str.length <= 6) return str;
  return `${str.slice(0, 3)}...${str.slice(-2)}`;
};

export const bucketRegion = (guest = {}) => {
  const region = guest.region || guest.query?.region || 'unknown';
  return region || 'unknown';
};

export const bucketDevice = (guest = {}) => {
  const dev = guest.device || guest.query?.device || 'web';
  const lower = String(dev).toLowerCase();
  if (lower.includes('mobile')) return 'mobile';
  if (lower.includes('tablet')) return 'tablet';
  if (lower.includes('desktop') || lower.includes('web')) return 'desktop';
  return 'unknown';
};

export const incrementCount = (obj, key, delta = 1) => {
  if (!key) return obj;
  const next = { ...obj };
  next[key] = (next[key] || 0) + delta;
  return next;
};

export const pruneOld = (map, windowMs, nowTs) => {
  const next = new Map();
  map.forEach((ts, id) => {
    if (nowTs - ts <= windowMs) next.set(id, ts);
  });
  return next;
};

export const extractReferrerHost = (guest = {}) => {
  const ref =
    guest.referrer ||
    guest.utm?.referrer ||
    guest.utm?.ref ||
    guest.query?.referrer ||
    guest.origin;
  if (!ref) return 'unknown';
  if (ref === 'direct') return 'direct';
  const currentHost =
    typeof window !== 'undefined' ? window.location.hostname : null;
  try {
    const url = new URL(ref);
    const host = url.hostname || 'unknown';
    if (currentHost && host === currentHost) return 'direct';
    return host;
  } catch {
    if (currentHost && ref === currentHost) return 'direct';
    return ref;
  }
};
